module.exports = __webpack_public_path__ + "static/media/logo.d0503867.svg";